<template>
  <base-submit-danger-modal ref="submitConfirmationModal"
                            :confirm-function="submitReview"
                            class="modal-class"
                            confirm-button-title="Confirm"
                            modal-title="Confirm submission">

    <p class="my-1 p-1 text-center">
      Do you want to submit this review?
    </p>
    <p class="p-1 custom-text-danger warning-text">
      Submitting is final and cannot be revoked.
    </p>

  </base-submit-danger-modal>

</template>

<script>
  import BaseSubmitDangerModal from '@/components/base-components/base-modals/BaseSubmitDangerModal';
  import { infrastructureMixin } from '@/mixins/infrastructure';

  export default {
    name: 'ReviewConfirmationModal',
    components: { BaseSubmitDangerModal },
    mixins: [infrastructureMixin],
    props: {
      isRapidAccess: {
        type: Boolean,
        default: false,
      },
      proposalId: {
        type: String,
        required: true,
      },
    },
    methods: {
      closeModal() {
        this.$refs.submitConfirmationModal.hide();
      },
      openModal() {
        this.$refs.submitConfirmationModal.show();
      },
      async submitReview() {
        const pathSegment = this.isRapidAccess ? 'rapid-access/' : '';
        try {
          await this.axios.patch(
            `/documents/${pathSegment}${this.proposalId}/review/${this.infrastructure}`,
          );
          this.$emit('refresh-proposals');
          this.$notify({ type: 'success', title: 'Submitted successfully!' });
        } catch (error) {
          if (error.response.data) {
            this.$notify({ type: 'error', title: error.response.data });
          } else {
            this.$notify({ type: 'error', title: 'Communication error' });
          }
        }
        this.closeModal();
      },
    },
  };
</script>

<style scoped>
  .warning-text {
    text-align: center;
  }
</style>
